<script setup lang="ts">
import { tpgIconEventNote } from '@tpg/grammar-web-icons';
import { useDebounceFn } from '@vueuse/core';

import type { GrammarMenuItemProps } from '@nora-monorepo/grammar-ui';

import MenuItemRow from '#nora-ui/map/components/overlay-menu/primitives/MenuItemRow.vue';
import { useMapStore } from '#nora-ui/map/stores/map-store';

interface NotificationLayerMenuItemProps {
  mapId: string;
}

const props = defineProps<NotificationLayerMenuItemProps>();

const mapStore = useMapStore();

const map = mapStore.getMapByIdOrThrow(props.mapId);

function onNotificationLayerVisibilityChanged() {
  map.state.notification.toggleVisibility();
}

function onToggleClusterNotificationsClick() {
  map.layers.notification.toggleClustering();
}

const menuItems: GrammarMenuItemProps[] = [
  {
    label: 'Toggle cluster',
    onSelect: useDebounceFn(onToggleClusterNotificationsClick, 100),
  },
];
</script>

<template>
  <MenuItemRow
    title="Events"
    :icon="tpgIconEventNote"
    :menu-items="menuItems"
    :visible="map.state.notification.notificationLayerVisible"
    @visibility-changed="onNotificationLayerVisibilityChanged"
  />
</template>
